import { render, staticRenderFns } from "./ReviewDiligenceExceptionModal.vue?vue&type=template&id=3385bfb6"
import script from "./ReviewDiligenceExceptionModal.vue?vue&type=script&lang=ts"
export * from "./ReviewDiligenceExceptionModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3385bfb6')) {
      api.createRecord('3385bfb6', component.options)
    } else {
      api.reload('3385bfb6', component.options)
    }
    module.hot.accept("./ReviewDiligenceExceptionModal.vue?vue&type=template&id=3385bfb6", function () {
      api.rerender('3385bfb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/Modals/ReviewDiligenceExceptionModal.vue"
export default component.exports